(() => {
  const labels = {
    el: 'Χονδρική & εκπτώσεις ποσότητας',
    en: 'Wholesale & quantity discounts',
    fr: 'Tarifs de gros et remises par quantité',
    nl: 'Groothandelsprijzen en staffelkorting',
    cs: 'Velkoobchodní ceny a množstevní slevy',
    de: 'Großhandel & Mengenrabatte',
    es: 'Precios mayoristas y descuentos por cantidad'
  };

  const syncQuantityTables = () => {
    document
      .querySelectorAll('.product__info-container .price > .clay-quantity-grid-table-container')
      .forEach((grid) => {
        const info = grid.closest('.product__info-container');
        const form = info && info.querySelector('.product-form');
        if (!info || !form) return;

        let anchor = form;
        while (anchor.parentElement && anchor.parentElement !== info) {
          anchor = anchor.parentElement;
        }
        if (anchor.parentElement !== info) return;

        let details = info.querySelector('.natura-volume-pricing');
        if (!details) {
          details = document.createElement('details');
          const summary = document.createElement('summary');
          const locale = document.documentElement.lang.split('-')[0];

          details.className = 'natura-volume-pricing';
          summary.className = 'natura-volume-pricing__summary';
          summary.textContent = labels[locale] || labels.en;
          details.appendChild(summary);
          anchor.insertAdjacentElement('afterend', details);
        }

        const signature = grid.textContent.replace(/\s+/g, ' ').trim();
        if (details.dataset.signature === signature) return;

        const clone = grid.cloneNode(true);
        const current = details.querySelector('.clay-quantity-grid-table-container');
        clone.removeAttribute('id');

        if (current) {
          details.replaceChild(clone, current);
        } else {
          details.appendChild(clone);
        }

        details.dataset.signature = signature;
        document.documentElement.dataset.naturaQuantityPricing = 'ready';
      });
  };

  const start = () => {
    const info = document.querySelector('.product__info-container');
    syncQuantityTables();
    if (!info || info.dataset.naturaQuantityObserver === 'ready') return;

    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(syncQuantityTables);
    });
    observer.observe(info, { childList: true, subtree: true });
    info.dataset.naturaQuantityObserver = 'ready';
  };

  document.documentElement.dataset.naturaConversion = 'loaded';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.setTimeout(start, 1000);
  window.setTimeout(start, 2500);
  document.addEventListener('shopify:section:load', start);
})();